import { FiltersState } from "../../../common/hooks/useFilters";
import { ArtifactType } from "../../../types/artifact";
import type { InteractionFilter, InteractionFilterFields, RowSelectionMode } from "../stores/chatTypes";

interface InteractionIdRow {
  ["interaction_id"]?: string;
}

interface SelectionFilterChangeParams {
  currentIds: string[];
  lastSelectedContext: { interactionIds: string[]; filter: InteractionFilterFields | null };
  filters: InteractionFilterFields;
}

const EMPTY_SYMMETRIC_DIFF_SIZE = 0;

export const extractInteractionIds = (rows: InteractionIdRow[]): string[] =>
  rows
    .filter((row) => row["interaction_id"])
    .map((row) => row["interaction_id"] as string);

const normalizeFilter = (filters: InteractionFilterFields): string =>
  JSON.stringify([
    filters.timeRange,
    filters.sentiment,
    filters.relevance,
    filters.risk,
    filters.protocol,
    filters.user,
    filters.processDecision,
    filters.callType,
    filters.search,
    filters.scoreRange
  ]);

export const buildInteractionFilter = (
  filters: FiltersState,
  rowSelectionMode: RowSelectionMode,
  includedArtifactTypes: ArtifactType[]
): InteractionFilter => ({
  timeRange: filters.timeRange,
  sentiment: filters.sentiment,
  relevance: filters.relevance,
  risk: filters.risk,
  protocol: filters.protocol,
  user: filters.user,
  processDecision: filters.processDecision,
  callType: filters.callType,
  search: filters.search,
  scoreRange: filters.scoreRange,
  rowSelectionMode,
  includedArtifactTypes
});

export const areInteractionIdsEqual = (
  idsA: string[],
  idsB: string[]
): boolean =>
  idsA.length === idsB.length &&
  new Set(idsA).symmetricDifference(new Set(idsB)).size === EMPTY_SYMMETRIC_DIFF_SIZE;

export const hasInteractionsOrFilterChanged = ({
  currentIds,
  lastSelectedContext,
  filters
}: SelectionFilterChangeParams): boolean => {
  const idsChanged = !areInteractionIdsEqual(currentIds, lastSelectedContext.interactionIds);
  const filtersChanged = lastSelectedContext.filter !== null &&
    normalizeFilter(lastSelectedContext.filter) !== normalizeFilter(filters);
  return idsChanged || filtersChanged;
};
